export default __webpack_public_path__ + "static/media/exam_2.1d74bc6c.svg";